// import axios from 'axios'
import axios from '../../helpers/Axios'

export const sectormodule = {

	namespaced: true,

	state: {

		allSectors: []
	},
	getters: {

		allSectors: state => { return state.allSectors; }
	},
	actions: {

		getSectors({ commit }) {
			return axios.get('/Sector').then(response => {

				commit('allSectors', response.data);

			}).catch(err => {
				console.log(err);
			});
		}
	},
	mutations: {

		allSectors(state, sectors) {
			state.allSectors = sectors
		}
	}
}
